import React, {useState, useContext} from "react";
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    useDisclosure,
    Input,
    Text,
    Textarea,
    VStack,
    Icon,
} from "@chakra-ui/react";
import { FaRobot } from "react-icons/fa";
import { useNavigate } from "react-router";
import { StaticUploadImage } from "../StaticUploadImage";
import { useStore } from "../../Store";
import { ModalBox } from "../ModalBox";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { useBreadcrumbs } from '../../contexts/BreadcrumbProvider';
import { ResourcesPage } from "../../pages/ResourcesPage";

export const CourseDetails = ({ 
    prompt, 
    setPrompt, 
    createContent, 
    product, 
    loading,
    type,
}) => {
    const [bookMediaUrl, setBookMediaUrl] = useState("")
    const [courseMediaUrl, setCourseMediaUrl] = useState("")
    const {updateStates} = useStore((state) => state);
    const { publisher } = useContext(PublisherAndUserContext);
    const {
        isOpen,
        onOpen,
        onClose,
    } = useDisclosure();
    const {
        isOpen: selectResourceIsOpen,
        onOpen: selectResourceOnOpen,
        onClose: selectResourceOnClose,
    } = useDisclosure();
    const navigate = useNavigate();
    const { addBreadcrumb } = useBreadcrumbs();

    const selectMedia = (rType, url, data) => { //All argument needed
        if(type === "book") {
            setBookMediaUrl(url)
        } else {
            setCourseMediaUrl(url)
        }
    }

    const selectImage = () => {
        updateStates({ [type]: { ...product, coverPath: type === "book" ? bookMediaUrl : courseMediaUrl }})
        selectResourceOnClose()
    }

    const upgradeToPro = () => {
        addBreadcrumb("Pricing Plan", "/pricingplan", true)
        navigate("/pricingplan")
    }

    return (
        <Box w="100%">
            {/* Header */}
            <Heading as='h3' size='lg' mb={4} textTransform="capitalize">{type} Details</Heading>
            <Text fontSize="md" mb={8} color="gray.600">Fill up the details of the {type}</Text>

            {/* Main Form */}
            <Box bg="white" p={6} rounded="lg" shadow="sm">
                <VStack align="stretch" spacing={6}>
                    {/* AI Assistant Section */}
                    <Box bg="gray.50" p={4} rounded="lg">
                        <Flex justify="space-between" align="center">
                            <Flex align="center">
                                <Icon as={FaRobot} color="blue.500" />
                                <Text ml={2} fontWeight="medium">AI Assistant</Text>
                            </Flex>
                        </Flex>
                        <Textarea
                            mt={4}
                            placeholder={`Describe your ${type}...`}
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                        />
                        <Button w="full" mt={4} colorScheme="blue" onClick={publisher.creditsAvailable + publisher.extraCreditsAvailable > 0 ? createContent : onOpen} isDisabled={!prompt} onOpentextTransform="capitalize">
                            Generate {type} Detail
                        </Button>
                    </Box>
                    <FormControl isDisabled={loading} isRequired={true}>
                        <FormLabel textTransform="capitalize">{type} Title</FormLabel>
                        <Input
                            value={product.name}
                            onChange={(e) => updateStates({ [type]: { ...product, name: e.target.value }})}
                        />
                    </FormControl>

                    <FormControl isDisabled={loading} isRequired={true}>
                        <FormLabel textTransform="capitalize">{type} Heading</FormLabel>
                        <Input
                            value={product.heading}
                            onChange={(e) => updateStates({ [type]: { ...product, heading: e.target.value }})}
                        />
                    </FormControl>

                    <FormControl isDisabled={loading} isRequired={true}>
                        <FormLabel textTransform="capitalize">{type} Description</FormLabel>
                        <Textarea
                            value={product.description}
                            onChange={(e) => updateStates({ [type]: { ...product, description: e.target.value }})}
                        />
                    </FormControl>
                    <Box>
                        <StaticUploadImage
                            label="Cover Image"
                            imageUrl={product.coverPath ? product.coverPath : ""}
                            maxSize={5}
                            maxWidth={600}
                            maxHeight={400}
                            parentCallback={(img_file) => {
                                updateStates({ [type]: { ...product, coverPath: img_file }})
                            }}
                            isRequired={true}
                            isDisabled={loading}
                            mediaUrl={type === "book" ? bookMediaUrl : courseMediaUrl}
                        />
                        <Button
                            onClick={selectResourceOnOpen}
                            background="transparent"
                            padding="0"
                            margin="0"
                            color="#2b6cb0"
                            textDecoration="underline"
                            _hover={{ bg: "transparent" }}
                            size="sm"
                            >
                            Select From Resource
                        </Button>
                    </Box>
                </VStack>
            </Box>
            <ModalBox
                title="Upgrade"
                isOpen={isOpen}
                onClose={onClose}
                isFooter={true}
                onCancel={onClose}
                confirmButtonType={true}
                onConfirm={upgradeToPro}
                isDeleteButton={false}
                confirmButtonText="Upgrade To Pro"
                description={`You’ve used all your available credits.
                Please upgrade to Pro to continue using this feature.`}
            />
            <ModalBox
                title="Select"
                size="xl"
                description={
                    <ResourcesPage type="images" isHideFilter={true} isHideUpload={true} isSelection={true} selectMedia={selectMedia} imageUrl={type === "book" ? bookMediaUrl : courseMediaUrl}/>
                }
                onClose={selectResourceOnClose}
                isOpen={selectResourceIsOpen}
                onCancel={selectResourceOnClose}
                isFooter={true}
                confirmButtonType={false}
                onConfirm={selectImage}
                confirmButtonText="Select"
            />
        </Box>
    );
};

